import { useQuery } from "react-query";
import qs from "qs";
import URL from "core/resources/urls";
import http from "infra/http";
import { RdoDetailChartParams } from "../partials/diario/rdoDetailChartParams";
import { RdoCurvaSResponse } from "../partials/diario/rdoCurvaS.types";

type Params = {
  params?: RdoDetailChartParams | null;
  enabled?: boolean;
};

export function useGetRdoCurvaS({ params, enabled = true }: Params = {}) {
  const canFetch =
    enabled &&
    !!params?.UnidadeId &&
    !!params?.SafraId &&
    !!params?.safraPeriodoId &&
    !!params?.operacaoClasseId;

  return useQuery(
    [URL.RELATORIO.DIARIO_OPERACOES_CURVA_S, params],
    async (): Promise<RdoCurvaSResponse> => {
      const { data } = await http.get<RdoCurvaSResponse>(
        URL.RELATORIO.DIARIO_OPERACOES_CURVA_S,
        {
          params,
          paramsSerializer: (p) => qs.stringify(p, { indices: false }),
          headers: { "api-version": "1.0" },
        }
      );
      return data;
    },
    { enabled: canFetch }
  );
}
